class ProductCard extends HTMLElement {
  constructor() {
    super();

    this.carouselButtons = this.querySelector('[carousel_buttons]');
    this.wishlistButton = this.querySelector('[wishlist_button]');
    this.id = this.getAttribute('data-id');
    this.page = this.getAttribute('data-page');
    this.url = this.querySelector('a').getAttribute('href');

    if (this.id && this.page && this.url) {
      this.addEventListener('click', (ev) => {
        if (ev.target.closest('button')) {
          return;
        }
        if (ev.metaKey || ev.ctrlKey) {
          return;
        }
        this.setHistory(this.id, this.page, this.url);
      });
    }

    this.addEventListener('keydown', (ev) => {
      if (ev.key === 'Space' || (ev.key === 'Enter' && ev.target.type !== 'button')) {
        this.querySelector('a')?.click();
      }
    });
  }

  connectedCallback() {
    this.addEventListener('focusin', this.onEnter.bind(this));
    this.addEventListener('focusout', this.onLeave.bind(this));
  }

  onEnter() {
    this.carouselButtons?.classList.add('opacity-100');
    this.wishlistButton?.classList.add('tablet:opacity-100');
  }

  onLeave() {
    this.carouselButtons?.classList.remove('opacity-100');
    this.wishlistButton?.classList.remove('tablet:opacity-100');
  }

  setHistory(id, page, url) {
    let stateData = history.state || {};
    stateData.collection_item_id = id;
    if (page) {
      history.replaceState(stateData, '', this.getUrlForPage(page));
    } else {
      history.replaceState(stateData, '');
    }
    history.scrollRestoration = 'auto';
    window.location.href = url;
  }

  getUrlForPage(page) {
    const url = new URL(window.location.href);
    const params = new URLSearchParams(url.search);

    if (page == 1 && params.has('page')) {
      params.delete('page');
    } else {
      params.set('page', page);
    }

    url.search = params.toString();

    return url.toString();
  }
}

customElements.define('product-card', ProductCard);
